import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  wareHouseList (params) {
    return axios.post(global.IMS_INFO + '/warehouse/findAllWarehouse', params)
  },
  wareHouseDelete (params) {
    return axios.post(global.IMS_INFO + '/warehouse/deleteWarehouse', params)
  },
  wareHouseInsert (params) {
    return axios.post(global.IMS_INFO + '/warehouse/insertWarehouse', params)
  },
  wareHouseSetDefault (param) {
    return axios.post(global.IMS_INFO + '/warehouse/updateWarehouseDefaultFlag', param)
  },
  wareHouseUpdate (params) {
    return axios.post(global.IMS_INFO + '/warehouse/updateWarehouse', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/ims/warehouse.js